import UsersActivity from './UsersActivity.js';

export default UsersActivity;
